export const PAGE_SIZE = 25;

export const DisplayStatus: Record<string, string> = {
  uploaded: "Analyzing",
  validation_failed: "Validation failed",
  pending_approval: "Pending approval",
  analyzing: "Analyzing",
  awaiting_approval: "Pending approval",
  scheduled: "Scheduled",
  review: "In progress",
  rejected: "Failed",
  in_progress: "In progress",
  processing: "Processing",
  completed: "Completed",
  partially_completed: "Completed with issues",
  failed: "Failed",
  canceled: "Canceled",
  bulk_payment_canceled: "Canceled",
  wire_import_canceled: "Canceled",
  expired: "Expired",
  approval_expired: "Expired",
  rejected_approval: "Rejected",
  unknown: "Pending",
};
